import React from 'react'
import globeIcon from '../../../images/globe.png'
import './MenuLanguageDropdownTitle.scss'

const MenuLanguageDropdownTitle = ({languageText}) => {
    return (
        <span className={'menu-language-dropdown-title'}>
            <img src={globeIcon} alt={'globe-icon'} /> <span>{languageText}</span>
        </span>
    )
}

export default MenuLanguageDropdownTitle
